import { render } from "./Pedidos.vue?vue&type=template&id=322f185c&scoped=true"
import script from "./Pedidos.vue?vue&type=script&lang=ts"
export * from "./Pedidos.vue?vue&type=script&lang=ts"

import "./Pedidos.vue?vue&type=style&index=0&id=322f185c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-322f185c"

export default script